const polyfillFetch = async () => {
  if (typeof window.fetch === 'function') {
    return;
  }
  await import(/* webpackChunkName: "whatwg-polyfill" */ 'whatwg-fetch');
  return;
};

export default polyfillFetch;
